import React from "react";
import OptimizelyManager from "../core/OptimizelyManager";
import createOptimizelyClient from "../core/createOptimizelyClient";

// This key is not renamed from @argonaut/experiment/ExperimentsContext to @rea-argonaut/experiment/ExperimentsContext because its value needs to be shared by app shell and MFE
export const KEY = "@argonaut/experiment/ExperimentsContext";

export const getDefaultExperimentsContextValue = <
  Variables = { [variableKey: string]: unknown },
>() =>
  new OptimizelyManager<Variables>(
    createOptimizelyClient(),
    {
      isSignedIn: false,
    },
    new URLSearchParams(),
  );

/* eslint-disable no-var */
declare global {
  var ArgonautReactContext: {
    [key: string]: unknown;
  };
}
/* eslint-enable no-var */

const getExperimentsContext = <
  Variables = { [variableKey: string]: unknown },
>(): React.Context<OptimizelyManager<Variables>> => {
  globalThis.ArgonautReactContext = globalThis.ArgonautReactContext || {};

  globalThis.ArgonautReactContext[KEY] =
    globalThis.ArgonautReactContext[KEY] ||
    React.createContext<OptimizelyManager<Variables>>(
      getDefaultExperimentsContextValue<Variables>(),
    );
  return globalThis.ArgonautReactContext[KEY] as React.Context<
    OptimizelyManager<Variables>
  >;
};

export default getExperimentsContext;
